import { Tabs, Divider } from 'antd';
import { SnippetsOutlined , UserOutlined ,MailOutlined} from '@ant-design/icons';
import { useEffect, useState,useContext } from 'react';
import Profile from '../cred/Profile';
import Cookies from 'js-cookie';
import { CommonContext } from '../../../Context';
import constants from '../../../constants/constants';
import LandingPages from './LandingPages';
import { trackPageAccess } from '../../../globalFunctions/GlobalFunctions';
import EmailNotification from './EmailNotification';

const { TabPane } = Tabs;

const SettingsContainer = (props) => {
  const [loader,setLoader]=useState(false);
  const [showBoost,setShowBoost]=useState(false);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const isAdmin = Cookies.get(constants.COOKIE_IS_ADMIN);
  
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);

  //Render
  return (
    <div>
      <Tabs defaultActiveKey="1">
      <TabPane
        tab={ <span className='uppercase'><UserOutlined className='text-xl' />Profile</span> }
        key={1}
      >
        <Profile/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><MailOutlined className='text-xl' />Email Notifications</span> }
        key={3}
      >
        <EmailNotification/>
      </TabPane>
      {isAdmin==="true"?
      <TabPane
        tab={ <span className='uppercase'><SnippetsOutlined className='text-xl' />Landing Pages</span> }
        key={2}
      >
        <LandingPages/>
      </TabPane>:null}
      </Tabs>
    </div>
  );
};

export default SettingsContainer;